import Model from "../model"
import { ID } from "../types"

export type CommandName =
  | "create-idea"
  | "delete-ideas"
  | "move-ideas"
  | "colour-ideas"
  | "view-idea"
  | "set-idea-field"
  | "set-idea-source"
  | "create-fleeting-idea"
  | "delete-fleeting-idea"
  | "create-project"
  | "set-project-fields"
  | "delete-project"
  | "create-web-source"
  | "delete-web-source"
  | "set-web-source-field"
  | "set-web-source-fields"

export default abstract class Command {
  abstract name: CommandName
  abstract local(model: Model): any
  abstract undo(): Command[]
  timestamp: number = Date.now()
  syncable: boolean = true
  undoable: boolean = true
  abstract state: any
  abstract resolveConflicts(model: Model): any | null

  unResolvedState?: any

  redo(): Command {
    return this
  }
  merge(_previous: Command | undefined): Command | undefined {
    return undefined
  }
  openIdea(): [ID, number] | undefined {
    return undefined
  }
}
